import { css, cx } from "@emotion/css"
import { queryCache, useMutation } from "react-query"

import AutoCompleteInput from "components/inputs/AutoComplete"
import React from "react"
//import { Combobox } from "components/inputs/Combobox"
import { getAllTimezones } from "countries-and-timezones"
import { updateMarket } from "api/regions"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"

type Option = {
  value: string
  label?: string
}

export const TimeZone = () => {
  const { t } = useI18n()
  const { meta, hasAuthority, updateUserMeta } = useAuthenticated()
  const { timeZone = "Etc/UTC", layerId } = meta ?? {}

  const timezones = getAllTimezones()

  const options = Object.keys(timezones)?.map((timezone) => {
    const option = timezones[timezone as keyof typeof timezones]
    const label = `(UTC${option.utcOffsetStr}) ${option.name}`
    return { value: option.name, label }
  }) as Option[]

  const initialTimezone = options.find((o) => o.value === timeZone) || {
    value: "Etc/UTC",
  }

  const [tz, setTz] = React.useState<Option>(initialTimezone)
  //const [currency, setCurrency] = React.useState<string>(initialCurrency)

  const [patch] = useMutation(updateMarket, {
    onSuccess: () => {
      queryCache.invalidateQueries("markets")
      updateUserMeta()
    },
  })

  // const renderCurrencyOption = (option: CurrencyOption) => (
  //   <React.Fragment>
  //     <span className={styles.options.short}>{option.symbol}</span>
  //     <span className={styles.options.label}>{option.label}</span>
  //   </React.Fragment>
  // )

  const onTimezoneChange = (opt: Option | null) =>
    !!opt?.value ? setTz(opt) : setTz(initialTimezone)

  const onTimezoneBlur = (
    evt: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { value } = evt.target
    const timezone = value.split(" ")[1]
    patch({
      id: layerId,
      timeZone: timezone,
    })
  }

  // const handleCurrencyChange = (
  //   _: React.ChangeEvent<any>,
  //   option: CurrencyOption | null,
  // ) => {
  //   setCurrency("")
  //   !!option && setCurrency(option.value)
  // }

  return (
    <div className={styles.wrapper}>
      <strong className={styles.title}>{t("admin.timeZone.title")}</strong>
      <div className={styles.row}>
        {/*<span className={cx("BodyBody1Regular", styles.text)}>
          {t("admin.timeZone.currency")}
        </span>
         <div className={styles.autocomplete}>
          <Combobox<CurrencyOption>
            name="currencyCode"
            options={currencies_options}
            renderOption={renderCurrencyOption}
            value={currency}
            onChange={handleCurrencyChange}
            label={t("inputs.currency")}
            margin={margin}
            size={size}
            groupBy={(option) =>
              option.popular
                ? t("inputs.currencies.popular")
                : t("inputs.currencies.all")
            }
            getSelectedOptionLabel={(option) => option?.symbol || ""}
          />
        </div> */}
      </div>
      <div className={styles.row}>
        <span className={cx("BodyBody1Regular", styles.text)}>
          {t("admin.timeZone.picker")}
        </span>
        <div className={styles.autocomplete}>
          <AutoCompleteInput
            size="medium"
            margin="dense"
            disableClearable
            data-test-id="timeZone-selector"
            options={options}
            onChange={onTimezoneChange}
            onBlur={onTimezoneBlur}
            getOptionSelected={(option, value) => {
              return option?.value === value?.value
            }}
            renderOption={(option) => <span>{option?.label}</span>}
            getOptionLabel={(option) => `${option?.label}`}
            value={tz}
            fetchOnFilter={false}
            className={styles.input}
            disabled={!hasAuthority(["AUTH_EDIT_MARKET_TIMEZONE"])}
          />
        </div>
      </div>
    </div>
  )
}

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    padding: var(--spacing-m) 0 var(--spacing-xxs);
  `,
  title: css`
    font-size: 14px;
    color: var(--black);
    margin-bottom: var(--spacing-m);
    > * {
      margin-bottom: 1px;
    }
  `,
  text: css`
    margin-top: var(--spacing-xxs);
    min-width: 80px;
  `,
  options: {
    short: css`
      color: var(--black);
      font-size: 0.8125rem;
      min-width: 2.5rem;
    `,
    label: css`
      color: var(--dark-grey);
      font-size: 0.8125rem;
      margin-left: 0.1rem;
    `,
  },
  row: css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  autocomplete: css`
    min-width: 270px;
  `,
  input: css`
    .MuiOutlinedInput-inputMarginDense {
      font-size: 13px;
    }
  `,
}
